__turbopack_context__.v({
  "hero": "heroDynamic-module-scss-module__WP4DVG__hero",
  "heroContent": "heroDynamic-module-scss-module__WP4DVG__heroContent",
});
